import { render, staticRenderFns } from "./UltimaResposta.vue?vue&type=template&id=4bd80589&scoped=true"
import script from "./UltimaResposta.vue?vue&type=script&lang=js"
export * from "./UltimaResposta.vue?vue&type=script&lang=js"
import style0 from "./UltimaResposta.vue?vue&type=style&index=0&id=4bd80589&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd80589",
  null
  
)

export default component.exports